import store from "../stores";

export const getUrlBasedOnCurrentLanguage = (key: string) => {
  const links = JSON.parse(JSON.stringify(FaqLinks));
  if(!links[key]) return null;
  if (!links[key].spanishUrl) return links[key].url;

  const currentLanguage = store.getState().language.current.toLocaleLowerCase();
  if (currentLanguage === "es-es") return links[key].spanishUrl;
  return links[key].url;
};

export interface IFAQItem {
  key: string;
  tooltip?: string;
  url?: string;
  spanishUrl?: string;
}

export interface IFAQItemGroup extends IFAQItem {
  items: {
    [key: string]: IFAQItem;
  };
}

export interface IFAQItems {
  [key: string]: IFAQItem | IFAQItemGroup;
}

export const FaqLinks: IFAQItems = {
  DETAILS: {
    key: "DETAILS",
    tooltip: "Layout.Header.Tooltips.DetailsPage",
    url: "https://faq.yoello.com/knowledge/updating-your-merchant-details",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  PRINTER_SETTINGS: {
    key: "PRINTER_SETTINGS",
    tooltip: "Layout.Header.Tooltips.PrinterSettingsPage",
    url: "https://faq.yoello.com/knowledge/star-printer-settings",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  //different spanish url
  PAYMENTS: {
    key: "PAYMENTS",
    tooltip: "Layout.Header.Tooltips.PaymentsPage",
    url: "https://faq.yoello.com/knowledge/setting-up-payments",
    spanishUrl:
      "https://faq.yoello.com/es/knowledge/panel-del-comerciante#pagos",
  },
  //different spanish url
  EPOSNOW: {
    key: "EPOSNOW",
    tooltip: "",
    url:
      "https://faq.yoello.com/knowledge/merchant-dashboard#epos-now-menu-management",
    spanishUrl:
      "https://faq.yoello.com/es/knowledge/panel-del-comerciante#gesti%C3%B3n-del-men%C3%BA-en-epos-now",
  },
  SUBCATEGORIES: {
    key: "SUBCATEGORIES",
    tooltip: "Layout.Header.Tooltips.SubcategoriesPage",
    url: "https://faq.yoello.com/knowledge/subcategories",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  ITEMS: {
    key: "ITEMS",
    tooltip: "Layout.Header.Tooltips.ItemsPage",
    url: "https://faq.yoello.com/knowledge/items",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  EXTRAS: {
    key: "EXTRAS",
    tooltip: "Layout.Header.Tooltips.ExtrasPage",
    url: "https://faq.yoello.com/knowledge/extras",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  PREFERENCES: {
    key: "PREFERENCES",
    tooltip: "Layout.Header.Tooltips.PreferencesPage",
    url: "https://faq.yoello.com/knowledge/preferences",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  //different spanish url
  MANAGE_MENU: {
    key: "MANAGE_MENU",
    tooltip: "Layout.Header.Tooltips.MenusPage",
    url: "https://faq.yoello.com/knowledge/how-do-i-set-up-a-menu",
    spanishUrl:
      "https://faq.yoello.com/es/knowledge/panel-del-comerciante#gesti%C3%B3n-de-productos-y-men%C3%BAs",
  },
  TRADING_TIMES: {
    key: "TRADING_TIMES",
    tooltip: "Layout.Header.Tooltips.TradingTimesPage",
    url: "https://faq.yoello.com/knowledge/trading-times",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  VENUE_SETTINGS: {
    key: "VENUE_SETTINGS",
    tooltip: "Layout.Header.Tooltips.VenueSettingsPage",
    url: "https://faq.yoello.com/knowledge/venue-settings",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  ORDER_SETTINGS: {
    key: "ORDER_SETTINGS",
    tooltip: "Layout.Header.Tooltips.OrderSettingsPage",
    url: "https://faq.yoello.com/knowledge/order-settings",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  TABLE_RANGES: {
    key: "TABLE_RANGES",
    tooltip: "",
    url: "https://faq.yoello.com/knowledge/venue-areas",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  VENUEIMAGES: {
    key: "VENUEIMAGES",
    tooltip: "Layout.Header.Tooltips.VenueImagesPage",
    url: "https://faq.yoello.com/knowledge/venue-images",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  EXTERNAL_LINKS: {
    key: "EXTERNAL_LINKS",
    tooltip: "Layout.Header.Tooltips.ExternalLinksPage",
    url: "https://faq.yoello.com/knowledge/external-links",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  QRCODE: {
    key: "QRCODE",
    tooltip: "",
    url: "https://faq.yoello.com/knowledge/qr-code",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  REPORTS: {
    key: "REPORTS",
    tooltip: "Layout.Header.Tooltips.ReportsPage",
    url: "https://faq.yoello.com/knowledge/reports",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  CUSTOMERS: {
    key: "CUSTOMERS",
    tooltip: "Layout.Header.Tooltips.CustomersPage",
    url: "",
    spanishUrl: "",
  },
  ORDER_HISTORY: {
    key: "ORDER_HISTORY",
    tooltip: "Layout.Header.Tooltips.OrderHistoryPage",
    url:
      "https://faq.yoello.com/knowledge/how-do-i-find-details-of-finished-orders",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  NEW_ORDERS: {
    key: "NEW_ORDERS",
    tooltip: "Layout.Header.Tooltips.NewOrdersPage",
    url:
      "https://faq.yoello.com/knowledge/how-do-i-manage-orders-via-the-dashboard",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  OPEN_ORDERS: {
    key: "OPEN_ORDERS",
    tooltip: "Layout.Header.Tooltips.OpenOrdersPage",
    url:
      "https://faq.yoello.com/knowledge/how-do-i-manage-orders-via-the-dashboard",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  MERCHANT_APP: {
    key: "MERCHANT_APP",
    tooltip: "Layout.Header.Tooltips.DetailsPage",
    url: "https://faq.yoello.com/knowledge",
    spanishUrl: "https://faq.yoello.com/es/knowledge/1/panel-del-comerciante",
  },
  //different spanish url
  TAXES: {
    key: "TAXES",
    tooltip: "Layout.Header.Tooltips.SalesTaxPage",
    url:
      "https://faq.yoello.com/knowledge/how-do-i-set-up-my-taxes-on-the-dashboard",
    spanishUrl:
      "https://faq.yoello.com/es/knowledge/panel-del-comerciante#impuestos-sobre-las-ventas",
  },
  SETUP_TAXES_EPOSNOW: {
    key: "SETUP_TAXES_EPOSNOW",
    tooltip: "",
    url:
      "https://faq.yoello.com/knowledge/epos-now-how-to-set-up-tax-on-merchant-dashboard",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  //different spanish url
  DISCOUNTS: {
    key: "DISCOUNTS",
    tooltip: "Layout.Header.Tooltips.DiscountsPage",
    url: "https://faq.yoello.com/knowledge/how-can-i-set-up-a-discount-code",
    spanishUrl:
      "https://faq.yoello.com/es/knowledge/panel-del-comerciante#descuentos",
  },
  VENUE_URL: {
    key: "VENUE_URL",
    tooltip: "Layout.Header.Tooltips.VenueURLPage",
    url: "https://faq.yoello.com/knowledge/qr-code",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  DOWNLOAD_QR_CODE: {
    key: "DOWNLOAD_QR_CODE",
    tooltip: "Layout.Header.Tooltips.DownloadQRCodePage",
    url: "https://faq.yoello.com/knowledge/qr-code",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
  SUBSCRIPTION: {
    key: "SUBSCRIPTION",
    tooltip: "Layout.Header.Tooltips.SubscriptionPage",
    url: "",
    spanishUrl: "",
  },
  //different spanish url
  USER_MANAGEMENT: {
    key: "USER_MANAGEMENT",
    tooltip: "Layout.Header.Tooltips.UserManagementPage",
    url: "https://faq.yoello.com/knowledge/user-permissions",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante#gesti%C3%B3n-de-usuarios",
    
  },
  OPENBANKING: {
    key: "OPENBANKING",
    tooltip: "Layout.Header.Tooltips.OpenBanking",
    url: "https://faq.yoello.com/knowledge/open-banking",
    spanishUrl: "https://faq.yoello.com/es/knowledge/panel-del-comerciante",
  },
};
